import { INK, MUTED } from '../Landing/ui';

// Expedition-journal text input. Pages under the `signup-flow` reset get
// `all: unset` on inputs, so every visual property is set explicitly here.
export default function JournalField({
  label,
  id,
  hint,
  error,
  valid,
  adornment,
  rightSlot,
  className = '',
  inputClassName = '',
  ...inputProps
}) {
  const borderState = error
    ? 'tw-border-red-500'
    : valid
    ? 'tw-border-primary-600'
    : 'tw-border-[#E7E0CF] dark:tw-border-[#26382F]';

  return (
    <div className={className}>
      {label && (
        <label
          htmlFor={id}
          className={`tw-mb-1.5 tw-block tw-text-sm tw-font-medium ${INK}`}
        >
          {label}
        </label>
      )}
      <div className="tw-relative">
        {adornment && (
          <span
            className={`tw-pointer-events-none tw-absolute tw-left-4 tw-top-1/2 -tw-translate-y-1/2 tw-text-base ${MUTED}`}
            aria-hidden="true"
          >
            {adornment}
          </span>
        )}
        <input
          id={id}
          className={`tw-block tw-w-full tw-rounded-xl tw-border tw-border-solid ${borderState} tw-bg-white dark:tw-bg-[#0F1D18] tw-px-4 tw-py-3 tw-text-base ${INK} placeholder:tw-text-[#8A958F] focus:tw-border-primary-600 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-primary-600/20 ${
            adornment ? 'tw-pl-9' : ''
          } ${rightSlot ? 'tw-pr-12' : ''} ${inputClassName}`}
          {...inputProps}
        />
        {rightSlot && (
          <div className="tw-absolute tw-right-3 tw-top-1/2 tw-flex -tw-translate-y-1/2 tw-items-center">
            {rightSlot}
          </div>
        )}
      </div>
      {error && typeof error === 'string' && (
        <p className="tw-mb-0 tw-mt-1.5 tw-text-sm tw-text-red-600 dark:tw-text-red-400">
          {error}
        </p>
      )}
      {hint && !error && (
        <p className={`tw-mb-0 tw-mt-1.5 tw-text-xs ${MUTED}`}>{hint}</p>
      )}
    </div>
  );
}
